import { render, staticRenderFns } from "./ClinicChainDic.vue?vue&type=template&id=1e51e6c3&scoped=true"
import script from "./ClinicChainDic.vue?vue&type=script&lang=js"
export * from "./ClinicChainDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicChainDic.vue?vue&type=style&index=0&id=1e51e6c3&lang=scss&scoped=true"
import style1 from "./ClinicChainDic.vue?vue&type=style&index=1&id=1e51e6c3&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51e6c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e51e6c3')) {
      api.createRecord('1e51e6c3', component.options)
    } else {
      api.reload('1e51e6c3', component.options)
    }
    module.hot.accept("./ClinicChainDic.vue?vue&type=template&id=1e51e6c3&scoped=true", function () {
      api.rerender('1e51e6c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicChainDic.vue"
export default component.exports